export enum HoursOfOperationType {
    SelectHours,
    AlwaysOpen,
    Closed,
    Unknown
}
